import { admin } from '~/services/api';

export const getAppByDomain = domain => admin.get(`/apps?domain=${domain}`);
